module.exports = __webpack_public_path__ + "static/media/peanut-butter.a17681d4.jpg";